import NamedDto from 'modules/base/dto/NamedDto';

export class ExpressionModelOutputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.expression = null;
		/** @type {string} */
		this.uom = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _ExpressionModelOutputAttributeEditDtoProps
	 * @property {string} expression
	 * @property {string} uom
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ExpressionModelOutputAttributeEditDtoProps} ExpressionModelOutputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {ExpressionModelOutputAttributeEditDtoProps} props
	 * @returns {ExpressionModelOutputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.expression = props.expression;
		this.uom = props.uom;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default ExpressionModelOutputAttributeEditDto;
